module.exports = __webpack_public_path__ + "img/5.0265844a.jpg";